import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { setSentryAuthContext, clearSentryContext } from '../lib/sentry';

/**
 * Component to sync auth context with Sentry
 * This ensures Sentry has the latest user and auth context for error reporting
 */
export function SentryAuthSync() {
  const { data: authContext, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    if (authContext) {
      // Sync auth context to Sentry
      setSentryAuthContext(authContext);
    } else {
      // Clear Sentry context when logged out
      clearSentryContext();
    }
  }, [authContext, isLoading]);

  return null; // This component doesn't render anything
}
